<template>
  <div> 发布动态 </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.getTopicList()
  },
  methods: {
    getTopicList() {
      let params = {
        data_type: 1,
        type: 1
      }
      this.http.getWx('member/AppCamp/getTopicList', params, (rs) => {
        if (rs.data.code == 200) {
        }
      })
    }
  }
}
</script>
